module.exports = __webpack_public_path__ + "media/images/static/top/urban/STAY_mobile-93c321ecb823f28dbcd5775b60be3dc2.png";